var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFulgeas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_fulgeas",
    "data-name": "logo fulgeas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 30.601,
    viewBox: "0 0 24 30.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_118",
    "data-name": "Rettangolo 118",
    width: 24,
    height: 30.601,
    fill: "#ffc400"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_102",
    "data-name": "Raggruppa 102",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37",
    "data-name": "Tracciato 37",
    d: "M0,15.054,9.291,8.542,2.026,3.45V0l9.727,6.817L21.481,0V2.3a2.188,2.188,0,0,1-.858,1.749L16.435,6.987h0L4.923,15.054,10.1,18.685,7.643,20.41Zm24,.493-7.643-5.355L13.9,11.916l5.181,3.631-15.7,11A2.189,2.189,0,0,0,2.52,28.3v2.3l9.727-6.817L21.975,30.6V27.15l-7.266-5.092Z",
    fill: "#ffc400"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFulgeas);
export default __webpack_public_path__ + "static/media/logo_fulgeas.ec4fd9027341af79b927753038b500bd.svg";
export { ForwardRef as ReactComponent };